"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _sms = require("@/api/sms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'forgetPhone',
  props: {
    isIndex: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };

    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (_this.formInline.checkPass !== '') {
          _this.$refs.formInline.validateField('checkPass');
        }

        callback();
      }
    };

    return {
      cutNUm: '获取验证码',
      canClick: true,
      current: 0,
      formInline: {
        account: '',
        phone: '',
        code: '',
        password: ''
      },
      ruleInline: {
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: '请输入当前账号',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 短信验证码
    cutDown: function cutDown() {
      var _this2 = this;

      if (this.formInline.phone) {
        if (!this.canClick) return;
        this.canClick = false;
        this.cutNUm = 60;
        var data = {
          phone: this.formInline.phone,
          types: 1
        };
        (0, _sms.captchaApi)(data).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
            return _index.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.$message.success(res.msg);

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        var time = setInterval(function () {
          _this2.cutNUm--;

          if (_this2.cutNUm === 0) {
            _this2.cutNUm = '获取验证码';
            _this2.canClick = true;
            clearInterval(time);
          }
        }, 1000);
      } else {
        this.$message.warning('请填写手机号!');
      }
    },
    handleSubmit1: function handleSubmit1(name) {
      var _this3 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _sms.phoneValidatorApi)(_this3.formInline).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
              return _index.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _this3.$message.success('操作成功');

                      _this3.current = 1;

                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }());
        } else {
          return false;
        }
      });
    },
    handleSubmit2: function handleSubmit2(name) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _sms.updateHoneApi)(_this4.formInline).then( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
              return _index.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _this4.$message.success('操作成功');

                      _this4.current = 2;

                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }());
        } else {
          return false;
        }
      });
    },
    //登录
    handleSubmit: function handleSubmit(name, num) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _sms.configApi)({
            account: _this5.formInline.account,
            password: _this5.formInline.password
          }).then( /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(res) {
              return _index.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      num === 1 ? _this5.$message.success("原手机号密码正确") : _this5.$message.success("登录成功");
                      num === 1 ? _this5.current = 1 : _this5.$emit('on-Login');

                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }());
        } else {
          return false;
        }
      });
    },
    returns: function returns() {
      this.current === 0 ? this.$emit('gobackPhone') : this.current = 0;
    }
  }
};
exports.default = _default;